import { useEffect, useState } from "react";
import FbProfile from "../views/dashboard/profiles/Fbprofile";
import Igprofile from "../views/dashboard/profiles/Igprofile";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userProfile } from "../store/user/userThunk";

const SocialProfileTabs = () => {
    const { profile } = useSelector((state) => state.userservice);
    const [activeTab, setActiveTab] = useState(null); // Initialize as null

    const navigate = useNavigate()
    const dispatch = useDispatch()
    useEffect(() => {
        // if (profile === null)
        dispatch(userProfile()).then((resp) => {
            const profile = resp.payload
            const isLoggedIn = profile && (profile.iglogin || profile.Fblogin || profile.wpLogin);
            if (!isLoggedIn) {
                navigate('/settings');
            }
            console.log(resp.payload, "respresprespresp")
        }).catch((error) => {
            console.log(error.message)
        })
    }, [dispatch])

    const availableTabs = [
        profile?.Fblogin && "Facebook",
        profile?.iglogin && "Instagram",
    ].filter(Boolean); // Removes falsy values

    const stats = {
        Facebook: {
            posts: 690,
            followers: 206,
            following: 100
        },
        Instagram: {
            posts: 1200,
            followers: 540,
            following: 300
        }
    };

    const socialIcons = {
        Facebook: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.737-.9 10.125-5.864 10.125-11.854z" />
            </svg>
        ),
        Instagram: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
        )
    };

    // Auto-set default active tab if needed
    useEffect(() => {
        if (!activeTab && availableTabs.length > 0) {
            setActiveTab(availableTabs[0]);
        }
    }, [profile]);

    if (availableTabs.length === 0) {
        return (
            <div className="text-center py-8 text-gray-500">
                No connected social profiles.
            </div>
        );
    }

    return (
        <div className="  py-8">
            <Container>
                <div className="bg-white rounded-3xl shadow-sm overflow-hidden">
                    <div className="p-6">
                        {/* Tab Navigation */}
                        <div className="mb-8">
                            <div className="flex border-b">
                                {availableTabs.map((platform) => (
                                    <button
                                        key={platform}
                                        onClick={() => setActiveTab(platform)}
                                        className={`flex items-center px-8 py-4 font-medium text-lg transition-all duration-300 border-b-2 ${activeTab === platform
                                            ? 'border-[#50b5ff] text-[#50b5ff]'
                                            : 'border-transparent text-gray-500 hover:text-gray-700'
                                            }`}
                                    >
                                        <span className="mr-2">{socialIcons[platform]}</span>
                                        {platform}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Tab Content */}
                        <div className="mt-6">
                            {activeTab === 'Facebook' && profile?.Fblogin && (
                                <div className="animate-fadeIn">
                                    <FbProfile />
                                </div>
                            )}
                            {activeTab === 'Instagram' && profile?.iglogin && (
                                <div className="animate-fadeIn">
                                    <Igprofile />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default SocialProfileTabs;
